import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

// import logoBranca from '../../assets/images/logobranca.png';
import logoEthosx10 from '../../assets/images/10_anos_vetorizado.png';
import backgroundPDF from '../../assets/images/backgroundpdf.jpg'
import robotoRegular from '../../assets/fonts/Roboto-Regular.ttf'
import robotoMedium from '../../assets/fonts/Roboto-Medium.ttf'
import { styleSheet } from '../../assets/styles/global';
import { IProjects, ISchedule } from '../../interfaces/ISchedule';
import moment from 'moment';

interface Props {
  schedulesReport: ISchedule[];
  projectsReport: IProjects[];
  date: string;
}

Font.register({
  family: 'Roboto',
  format: 'truetype',
  src: robotoRegular
})

Font.register({
  family: 'Roboto',
  format: 'truetype',
  src: robotoMedium,
  fontWeight: 'bold'
})

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    width: '100%',
    height: '100%',
    padding: 5,
  },
  title: {
    color: '#334391',
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 6
  },
  subTitle: {
    fontSize: 10,
    color: '#334391',
    marginVertical: 6
  },
  table: {
    width: '100%',
    fontSize: 8,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  header: {
    backgroundColor: '#334391',
    color: '#fff'
  },
  bold: {
    fontWeight: 'bold',
  },
  // So Declarative and unDRY 👌
  col: {
    border: '0.5px solid #EEE',
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 2,

  },
  colBorderLess: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 2
  },
  col5: {
    width: '5%',
  },
  col10: {
    width: '10%',
  },
  col15: {
    width: '15%',
  },
  col20: {
    width: '20%',
  },
  col30: {
    width: '30%',
  },
  totalizer: {
    color: styleSheet.titleLight
  }
});

// Create Document Component
const ReportPdf: React.FC<Props>= ({date, schedulesReport, projectsReport}) => {
  return (
    <>
      <Document >
        <Page size="A4" orientation="landscape" style={styles.page}>
          <Text style={styles.title}>Relatório - {date}</Text>
          <Text style={styles.subTitle}>Relatório Atividades</Text>
          <View style={styles.table}>
            <View style={[styles.row, styles.bold, styles.header]}>
                <View style={[styles.col, styles.col10]}><Text>Os</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Data</Text></View>
                <View style={[styles.col, styles.col15]}><Text>Cliente</Text></View>
                <View style={[styles.col, styles.col30]}><Text>Projeto</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Local</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Inicio</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Fim</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Desconto</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Despesa - R$</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Total - hr</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Valor - hr</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Total - R$</Text></View>
            </View>

              {
                schedulesReport.map(item => (
                  <View key={item.key} style={styles.row} wrap={false}>
                    <View style={[styles.col, styles.col10]}><Text>{item.os}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{moment(item.data).format('DD/MM/YYYY')}</Text></View>
                    <View style={[styles.col, styles.col15]}><Text>{item.nomecli}</Text></View>
                    <View style={[styles.col, styles.col30]}><Text >{item.projeto.trim().substring(0, 37)} {item.projeto.trim().length > 37 ? '...' : ''}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{item.local}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{item.horaini}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{item.horafim}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{item.desconto}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>R$ {item.totDesp}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{item.horatot}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>R$ {item.valortot}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>R$ {item.valortot + item.totDesp}</Text></View>
                  </View>
                ))
              } 
               <View style={styles.row} wrap={false}>
                  <View style={styles.col10}><Text></Text></View>
                  <View style={styles.col10}><Text></Text></View>
                  <View style={styles.col15}><Text></Text></View>
                  <View style={styles.col30}><Text></Text></View>
                  <View style={styles.col10}><Text></Text></View>
                  <View style={styles.col10}><Text></Text></View>
                  <View style={styles.col10}><Text></Text></View>
                  <View style={styles.col10}><Text></Text></View>
                  <View style={[styles.colBorderLess, styles.col10, styles.totalizer]}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(schedulesReport.reduce((acc, schedule) => acc += schedule.totDesp, 0))}</Text></View>
                  <View style={[styles.colBorderLess, styles.col10, styles.totalizer]}><Text>{schedulesReport.reduce((acc, schedule) => acc += schedule.horatot, 0)}</Text></View>
                  <View style={[styles.colBorderLess, styles.col10, styles.totalizer]}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(schedulesReport.reduce((acc, schedule) => acc += schedule.valortot, 0))}</Text></View>
                  <View style={[styles.colBorderLess, styles.col10, styles.totalizer]}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(schedulesReport.reduce((acc, schedule) => acc += schedule.valortot, 0) + schedulesReport.reduce((acc, schedule) => acc += schedule.totDesp, 0))}</Text></View>
                </View>    
          </View>


          <Text style={styles.subTitle}>Relatório Projetos</Text>
          <View style={styles.table}>
            <View style={[styles.row, styles.bold, styles.header]}>
                <View style={[styles.col, styles.col30]}><Text>Projeto</Text></View>
                <View style={[styles.col, styles.col10]}><Text>Horas</Text></View>
                <View style={[styles.col, styles.col20]}><Text>Despesas</Text></View>
                <View style={[styles.col, styles.col20]}><Text>Valor - HR</Text></View>
                <View style={[styles.col, styles.col20]}><Text>Total</Text></View>
            </View>

              {
                projectsReport.map(project => (
                  <View key={project.nome} style={styles.row} wrap={false}>
                    <View style={[styles.col, styles.col30]}><Text>{project.nome}</Text></View>
                    <View style={[styles.col, styles.col10]}><Text>{project.horas}</Text></View>
                    <View style={[styles.col, styles.col20]}><Text>R$ {project.despesa}</Text></View>
                    <View style={[styles.col, styles.col20]}><Text>R$ {project.valor}</Text></View>
                    <View style={[styles.col, styles.col20]}><Text>R$ {project.valor + project.despesa}</Text></View>
                  </View>
                ))
              } 
               <View style={styles.row} wrap={false}>
                  <View style={styles.col30}><Text></Text></View>
                  <View style={[styles.colBorderLess, styles.col10, styles.totalizer]}><Text>{projectsReport.reduce((acc, project) => acc += project.horas, 0)}</Text></View>
                  <View style={[styles.colBorderLess, styles.col20, styles.totalizer]}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(projectsReport.reduce((acc, project) => acc += project.despesa, 0))}</Text></View>
                  <View style={[styles.colBorderLess, styles.col20, styles.totalizer]}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(projectsReport.reduce((acc, project) => acc += project.valor, 0))}</Text></View>
                  <View style={[styles.colBorderLess, styles.col20, styles.totalizer]}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(projectsReport.reduce((acc, project) => acc += project.valor, 0) + projectsReport.reduce((acc, project) => acc += project.despesa, 0))}</Text></View>
                </View>    
          </View>
        </Page>
      </Document>
    </>
  );
}

export default ReportPdf;